import { Theme } from '@mui/material/styles'
import { css } from '@emotion/react'

// Modal Box style (was inline in Box)
export const modalBoxStyle = {
  backgroundColor: 'white',
  padding: '16px',
  margin: '40px auto',
  maxWidth: '600px',
  outline: 'none',
}

// Table container style
export const tableContainerStyle = (theme: Theme) => css`
  position: absolute;
  top: ${theme.spacing(2)};
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;

  tr {
    cursor: pointer;
    user-select: none;
  }
  tbody tr:nth-of-type(odd):not(.Mui-selected):not(:hover) {
    background-color: ${theme.palette.grey[50]};
  }
  tbody tr.Mui-selected {
    background-color: ${theme.palette.secondary[200]};
  }
`

// Table head style
export const tableHeadStyle = () => ({
  backgroundColor: 'transparent',
})

// Table header cell style
export const tableHeaderCellStyle = (theme: Theme) => css`
  font-weight: 500;
  font-size: 14px;
  color: ${theme.palette.text.primary};
  position: relative;
  min-width: 80px;
  height: 32px;
  padding: 4px 8px;

  > div {
    position: absolute;
    top: 0;
    left: 8px;
    right: 8px;
    bottom: 0;
    user-select: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`

// Table cell style
export const tableCellStyle = (theme: Theme, isWorkspaceInvalid?: boolean) => css`
  font-size: 14px;
  color: ${theme.palette.text.secondary};
  padding: 0 12px;
  height: 36px;
  border: none;
  font-style: ${isWorkspaceInvalid ? 'italic' : 'normal'};
`
